// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3bqml","topBottomGutter":"Layout_topBottomGutter__rv28w"};